<div class="summary-wrapper" *ngIf="!isPaid; else paymentDone">
  <div class="main-left">
    <h1>
      <img src="assets/images/long_arrow.svg" alt="long arrow icon" />
      Summary
    </h1>

    <ul class="package-box">
      <li>       
        <p><strong>{{ getInvoiceType(invoiceType) }}</strong></p>
      </li>
    </ul>

    <ul class="price-details">
      <li><span><strong>Amount</strong></span> <span>AED {{ invoiceAmount }}</span></li>
      <li><strong>Total Amount</strong><strong>AED {{ invoiceAmount }}</strong></li>
    </ul>

    <ul>
      <div class="add-card">
        <div class="add_new_card">
          <p>{{ 'AddNewCard' | translate }}</p>
        </div>
        <div style="margin: 15px 0px">
          <div id="card-element">
            <!-- Stripe Card Element will be mounted here -->
          </div>
          <div id="card-errors" role="alert"></div>
        </div>
      </div>
    </ul>

    <button class="btnn" (click)="payOut()" [disabled]="!isCardComplete">Pay Now</button>
  </div>

  <!-- <div class="main-right">
    <img src="assets/images/cnslng_cmn.png" alt="illustration Promo" />
    <h3>Don't miss out on mastering new skills</h3>
    <p>20% off your course enrollment today!</p>
    <button class="btnn">Buy Now</button>
  </div> -->
</div>

<!-- Paid message -->
<ng-template #paymentDone>
  <div class="payment-success-container">
    <div class="payment-success-card">
      <div class="payment-icon">✅</div>
      <h2>Payment already completed</h2>
      <p>Thank you! Your invoice has been paid successfully.</p>
    </div>
  </div>
</ng-template>

